var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "searchContent", attrs: { id: "page_Container" } },
    [
      _c(
        "div",
        { staticClass: "page" },
        [
          _c(
            "form",
            { attrs: { action: "/" } },
            [
              _c("van-search", {
                attrs: { placeholder: "请输入搜索关键词", "show-action": "" },
                on: { search: _vm.onSearch, cancel: _vm.onCancel },
                model: {
                  value: _vm.value,
                  callback: function($$v) {
                    _vm.value = $$v
                  },
                  expression: "value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.list.length
            ? _c(
                "div",
                {
                  staticClass: "main-container searchHistory",
                  attrs: { id: "main-container" }
                },
                [
                  _c("div", { staticClass: "historyTop" }, [
                    _c("span", [_vm._v("历史搜索")]),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: require("../assets/img/myCenter/deleteCart.png"),
                        alt: ""
                      },
                      on: { click: _vm.deleteFun }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "historyBottom",
                      class: { hidden: _vm.hiddenFlag },
                      attrs: { id: "historyBottom" }
                    },
                    _vm._l(_vm.list, function(item, index) {
                      return _c(
                        "span",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              _vm.spanClick(item)
                            }
                          }
                        },
                        [_vm._v(_vm._s(item))]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.triangleShow
                    ? _c(
                        "div",
                        {
                          staticClass: "triangleContent",
                          on: { click: _vm.triangleFun }
                        },
                        [_c("div", { staticClass: "triangle" })]
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("van-dialog", {
            staticClass: "dialogStyle",
            attrs: {
              message: "确认删除全部历史记录？",
              "show-cancel-button": ""
            },
            on: { confirm: _vm.confirm },
            model: {
              value: _vm.show,
              callback: function($$v) {
                _vm.show = $$v
              },
              expression: "show"
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }